'use client'

import classNames from 'clsx'
import { ComponentPropsWithoutRef, forwardRef } from 'react'

import S from '../Table.module.scss'

export interface TableHeaderProps extends ComponentPropsWithoutRef<'thead'> {}

export const TableHeader = forwardRef<
  HTMLTableSectionElement,
  TableHeaderProps
>(({ className, children, ...props }, ref) => {
  return (
    <thead {...props} ref={ref} className={classNames(S.header, className)}>
      {children}
    </thead>
  )
})

TableHeader.displayName = 'Table.Header'
